import React, { Suspense } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';

const AiHubSmokePage = React.lazy(() => import('./AiHubSmokePage'));

export const aiHubSmokeRouter: RouteObject = {
  path: 'dev/ai-hub-smoke',
  element: (
    <Suspense
      fallback={
        <div className="tw-h-full tw-p-4">
          <Skeleton width="100%" height="100%" />
        </div>
      }
    >
      <Outlet />
    </Suspense>
  ),
  children: [{ index: true, element: <AiHubSmokePage /> }],
};
